import './lang-switcher.scss';